import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-cream-50 border-t border-dark-100 py-8 md:py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/99522d9a3a4519144bb99e3bc03ec0b1.jpeg"
              alt="Cemil Kuaför Logo"
              className="h-10 w-10 rounded-full object-cover"
            />
            <div>
              <p className="text-dark-950 font-semibold text-sm">Cemil Kuaför | Hair Design</p>
              <p className="text-dark-400 text-xs">Marmaris / Muğla</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <span className="text-dark-400 text-sm">{t('footer.followUs')}</span>
            <a
              href="https://instagram.com/cemilkuaformarmaris"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-dark-950 text-white hover:bg-champagne-600 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-sm" />
            </a>
            <a
              href="https://wa.me/905313459987"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-dark-950 text-white hover:bg-champagne-600 transition-colors cursor-pointer"
            >
              <i className="ri-whatsapp-line text-sm" />
            </a>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-dark-100 text-center">
          <p className="text-dark-400 text-xs">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}